<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersList from "@/router/views/admin/users-list";
import TradersList from "@/router/views/admin/traders-list";
import CustomerApi from "@/services/customers-api";
import UsersApi from "@/services/users-api";

export default {
  page: {
    title: "Gestion des abonnements",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,UsersList,TradersList},
  data() {
    return {
      allTradersCount:0,
      allCustomersCount:0,
      isAdmin:true,
      hasCustomerUserManagementAccess:true,
      hasTradersUserManagementAccess:true,

    };
  }, 

    

    mounted(){
      
      if(this.isAdmin || this.hasTradersUserManagementAccess ){
        this.getTradersCount()
      }
      if(this.isAdmin || this.hasCustomerUserManagementAccess){
        this.getCustomersCount()
      }

      this.isAdmin= true;

      this.getTradersCount()
      this.getCustomersCount()

  },
    methods: {
      getTradersCount(){
        UsersApi.getTradersCount().then(
          result => {
            if(result){
              this.allTradersCount=result;
            }else{
              this.allTradersCount=0
            }
            
          }
        )
      },

      getCustomersCount(){
        CustomerApi.getCountCustomers().then(
          result => {
            if(result){
              this.allCustomersCount=result;
            }else{
              this.allCustomersCount=0
            }
            
          }
        )
      },

    }
};
</script>
<template>
  <Layout>

    <div>

              <!-- ---------- -->
    <!-- MAIN TITLE -->
    <div class="row pt-4 pb-4  d-print-none"  >
      
      <div class="col-12">
          <h2 class="text-dark font-weight-bold">Liste des comptes utilisateurs</h2>
          <h5  class="text-secondary"><span>{{this.allCustomersCount}}</span> {{$t('subscription.customers')}} et &nbsp;&nbsp; 
              <span>{{this.allTradersCount}}</span> {{$t('subscription.traders')}}</h5>
      </div>
      
 
  </div>
  <!-- MAIN TITLE -->
  <!-- ----------- -->


    <div class="row p-4 bg-white" style="border: 1px solid rgb(236, 237, 240);box-shadow: rgb(0 0 0 / 8%) 0px 2px 6px 0px;border-radius: 7px;">
      <div class="col-lg-12">

            <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
             <!-- <b-tabs content-class="p-3 text-muted"> -->
              <b-tab v-if="isAdmin || hasCustomerUserManagementAccess" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-user font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.customers')}}</span>
                  </template>
                  <UsersList />
                </b-tab>
                <b-tab v-if="isAdmin || hasTradersUserManagementAccess" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user-tie font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-user-tie font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.traders')}}</span>
                  </template>
                  <TradersList/>
                </b-tab>
            </b-tabs>
          </div>
        
    </div>


  </div>
  </Layout>
</template>

